import { ModalForm } from '../../../shared/ui/ModalForm/ModalForm'
import { modalActions, selectModalData } from '../../../entities/Modal'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { NotificationWithSubscribers } from '../../../entities/Notifications'
import {
	updateNotificationSubscribers
} from '../model/services/updateNotificationSubscribers'
import React, { BaseSyntheticEvent, SyntheticEvent, useMemo, useState } from 'react'
import { SubscribersCombobox } from './SubscribersCombobox'
import { selectCommonUsers } from '../../../entities/Common'

const modalStyles = {
	width: 865
}

export const EditNotificationSubscribersModal = () => {
	const dispatch = useAppDispatch()
	const commonUsers = useAppSelector(selectCommonUsers)
	const notificationWithSubscribers = useAppSelector(selectModalData) as NotificationWithSubscribers

	const subs = useMemo(() => notificationWithSubscribers.subscribers.map(
			subscriber => `${subscriber.email} (${subscriber.fullName})`)
		, [notificationWithSubscribers]
	)

	const [subscribers, setSubscribers] = useState(subs)

	const { handleSubmit } = useForm({ mode: 'onBlur' })

	const handleSubscribersChange = (
		e: SyntheticEvent<Element, Event>,
		value: string[]
	) => {
		setSubscribers(value)
	}

	const handleCancel = () => {
		dispatch(modalActions.hideModal())
	}

	const onSubmit: SubmitHandler<{}> = async (_, event) => {
		event?.preventDefault()
		const emailNamePair = subscribers.reduce((acc: any, sub) => {
			const [email, name] = sub.split(' ')
			acc[email] = name
			return acc
		}, {})

		const newSubscribers = commonUsers.reduce((acc: string[], user) => {
			if (emailNamePair[user.email]) acc.push(user.userId)
			return acc
		}, [])

		await dispatch(updateNotificationSubscribers({
			notificationId: notificationWithSubscribers.notificationId,
			subscribers: newSubscribers
		}))
		dispatch(modalActions.hideModal())
	}

	return (
		<ModalForm
			disabled={false}
			styles={modalStyles}
			modalTitle={'Edit notification subscribers'}
			handleCancel={handleCancel}
			handleOnSubmit={(e: BaseSyntheticEvent) =>
				handleSubmit(onSubmit({}, e))
			}
			disableCloseOnBackdropClick
		>
			<SubscribersCombobox
				subscribers={subscribers}
				handleSubscribersChange={handleSubscribersChange}
			/>
		</ModalForm>
	)
}